import React from 'react';
import { IconProps } from '.';

type GoInIconProps = {
  color?: string;
} & IconProps;

export const GoInIcon: React.FC<GoInIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill={color}
        d="M24.535 11.28a.386.386 0 000-.194.351.351 0 000-.193.687.687 0 00-.097-.157l-3.456-3.468a.496.496 0 00-.7.7l2.597 2.587H11.762a.495.495 0 100 .99H22.88l-2.598 2.574a.495.495 0 10.701.701l3.456-3.42a.69.69 0 00.097-.157"
      ></path>
      <path
        fill={color}
        d="M16.717 13.37a.495.495 0 00-.495.495v5.486h-7.19V5.177a.483.483 0 00-.254-.422l-5.92-3.348H16.22v6.888a.495.495 0 00.991 0V.912a.495.495 0 00-.495-.495H.912a.495.495 0 00-.495.495v18.91a.483.483 0 00.374.472l7.492 4.229a.423.423 0 00.241.06.603.603 0 00.254-.06.508.508 0 00.254-.435v-3.77h7.685a.495.495 0 00.495-.495v-5.958a.495.495 0 00-.495-.495zm-8.652 9.872l-6.573-3.71V1.77l6.573 3.697v17.775z"
      ></path>
    </svg>
  );
};
